import 'css-chunk:src/Header/Header.module.scss';export default {
  "header": "header__dsLY1",
  "box": "box__gp4jV"
};